import {useEffect, useState} from "react";
import {ListNotesPanelBody} from "~/components/notes/listNotesSidePanel";
import type {ProfileTabRenderProps} from "~/components/entityProfile/types";
import type {EventContainerWithEvents} from "~/utilities/apis/api";
import type {OttopilotEventContainer} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainer";

export type JourneyNotesTabContext = {
    journey: EventContainerWithEvents;
    notesEventContainerSourceLabel: string;
    composerKey: number;
    onJourneyPatched: (journey: OttopilotEventContainer) => void;
    onDirtyChange: (isDirty: boolean) => void;
};

export function ProfileNotesTabContent({
    tabRenderProps,
    context,
}: {
    tabRenderProps: ProfileTabRenderProps;
    context: JourneyNotesTabContext;
}) {
    const [journeyForNotes, setJourneyForNotes] = useState(context.journey);

    useEffect(() => {
        setJourneyForNotes(context.journey);
    }, [context.journey]);

    if (tabRenderProps.kind !== "journey") {
        return null;
    }

    return (
        <div className="h-full min-h-0 overflow-y-auto overscroll-contain px-ds-space-200 pb-ds-space-200">
            <ListNotesPanelBody
                key={`${journeyForNotes.id}-${context.composerKey}`}
                context={{
                    eventContainerId: journeyForNotes.id,
                    eventContainer: journeyForNotes,
                    createScope: {scopeType: "eventContainer"},
                    eventContainerSourceLabel: context.notesEventContainerSourceLabel,
                }}
                eventContainer={journeyForNotes}
                onEventContainerPatched={(patchedJourney) => {
                    setJourneyForNotes((previous) => ({
                        ...previous,
                        ...patchedJourney,
                    }));
                    context.onJourneyPatched(patchedJourney);
                }}
                isFullscreen={false}
                onDirtyChange={context.onDirtyChange}
            />
        </div>
    );
}
